export default "__VITE_ASSET__Dop3GwCq__"